import { t } from "@lingui/core/macro";

import { invariant } from "@/common/utils/invariant";
import { CropUnit } from "@/generated/digitalnisklady.cz/graphql";

const cropUnits = new Map<CropUnit, () => string>();
cropUnits.set(CropUnit.Kg, () => t`kg`);
cropUnits.set(CropUnit.L, () => t`l`);
cropUnits.set(CropUnit.T, () => t`t`);
cropUnits.set(CropUnit.Piece, () => t`kus`);
cropUnits.set(CropUnit.Package, () => t`balení`);

const getUnit = (unit: CropUnit) => {
  const translation = cropUnits.get(unit);
  //
  // eslint-disable-next-line lingui/no-unlocalized-strings
  invariant(translation, `Unknown crop unit: ${unit}`);

  return translation();
};

export { getUnit };
